export const EventHeight = 32;

// Vertical gap between events in pixels - controls spacing in month view
export const EventGap = 4;

// Height of hour cells in week and day views - controls the scale of time display
export const WeekCellsHeight = 70;

// Number of days to show in the agenda view
export const AgendaDaysToShow = 30;

// Start and end hours for the week and day views
export const StartHour = 6;
export const EndHour = 24;

// Default start and end times
export const DefaultStartHour = 6; // 9 AM
export const DefaultEndHour = 24; // 10 AM
